import {
  CmpNewsletterFieldsFragment,
  useUnpublishCmpNewsletterFromNewsroomMutation,
} from "../../../graphql/types";
import {
  EMAIL_CHAMBER_LOADING_MESSAGE,
  EMAIL_OPERATION_ERROR_CONTEXT,
} from "./emailBackendMappers";
import { UserFacingError } from "../../../utils/userFacingError";

// Unpublish Newsroom (Update Email review step) and Remove from Newsroom
// (Manage Emails row menu) share this call. The email itself is not changed.
export const useUnpublishNewsletterFromNewsroom = (chamberId: string) => {
  const [unpublishCmpNewsletterFromNewsroom] =
    useUnpublishCmpNewsletterFromNewsroomMutation({ context: EMAIL_OPERATION_ERROR_CONTEXT });

  const unpublishFromNewsroom = async (
    newsletterId: string | undefined
  ): Promise<CmpNewsletterFieldsFragment> => {
    if (!chamberId) {
      throw new UserFacingError(EMAIL_CHAMBER_LOADING_MESSAGE);
    }
    if (!newsletterId) {
      throw new UserFacingError("Save the email first, then try again.");
    }

    const result = await unpublishCmpNewsletterFromNewsroom({
      variables: { input: { chamberId, newsletterId } },
    });
    const unpublishResult = result.data?.unpublishCmpNewsletterFromNewsroom;
    const savedEmail = unpublishResult?.newsletter;

    if (
      unpublishResult?.newsletterSavedSuccessfully !== true
      || !savedEmail
    ) {
      throw new Error("The newsroom record could not be unpublished.");
    }

    return savedEmail;
  };

  return { unpublishFromNewsroom };
};
